import * as dd from 'dingtalk-jsapi';

export const DingtalkCorpId = process.env.VUE_APP_DD_CORP_ID;

export const isInDingtalk = (): boolean => {
  return dd.env.platform !== 'notInDingTalk';
};
